import style from './TextContent.module.css';

interface Props {
  children: string | string[] | JSX.Element | JSX.Element[];
}

function TextContent({ children }: Props) {
  return <div className={style.content}>{children}</div>;
}

export default TextContent;
